import { withDevtools } from "@angular-architects/ngrx-toolkit";
import { computed, effect, inject } from "@angular/core";
import { ConfigurationListeVersements, FiscaliteVersement } from "@mra/hlp9002";
import { getState, patchState, signalStore, withComputed, withHooks, withMethods, withState } from "@ngrx/signals";
import { LocalStorageService, StateKey } from "../shared/services/local-storage.service";
import { VersementState } from "./state";

function createDefaultState(): VersementState {
    return {
        fiscaliteVersement: null,
        versementConfig: null,
        editedIban: ""
    };
}

// eslint-disable-next-line @typescript-eslint/typedef
export const versementStore = signalStore(
    { providedIn: "root" },
    withDevtools("versement"),
    withState(createDefaultState()),
    withComputed((state) => ({
        getState: computed(() => ({
            fiscaliteVersement: state.fiscaliteVersement(),
            versementConfig: state.versementConfig(),
            editedIban: state.editedIban()
        })),
        tauxTmi: computed(() => state.fiscaliteVersement()?.tauxTMI ?? 30),
        deductionFiscaleActive: computed(() => state.fiscaliteVersement()?.choixDeduction === "auVersement")
    })),

    withMethods((store) => ({
        retrieveState(savedState: VersementState): void {
            patchState(store, () => savedState ?? createDefaultState());
        },

        unsetSimulation(): void {
            patchState(store, () => createDefaultState());
        },

        setFiscalite(fiscaliteVersement: FiscaliteVersement): void {
            patchState(store, () => ({ fiscaliteVersement }));
        },

        setVersementConfig(versementConfig: ConfigurationListeVersements): void {
            patchState(store, () => ({ versementConfig }));
        },

        setIBAN(editedIban: string): void {
            patchState(store, () => ({ editedIban }));
        }
    })),

    withHooks((store) => {
        const localStorageService: LocalStorageService = inject(LocalStorageService);

        return {
            onInit() {
                const state: VersementState | null = localStorageService.getSavedState<VersementState>(StateKey.VERSEMENT);
                if (state) store.retrieveState(state);
                effect(() => {
                    const state: VersementState = getState(store);
                    localStorageService.saveState(StateKey.VERSEMENT, state);
                });
            }
        };
    })
);

export type VersementStore = InstanceType<typeof versementStore>;
